import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import ProductCard from './ProductCard';

const CategoryPreview = ({ title, category, products, linkTo }) => {
  const categoryProducts = products.filter(p => p.category === category).slice(0, 3);
  if (categoryProducts.length === 0) return null;

  return (
    <div>
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="mb-8 flex items-end justify-between"
      >
        <div>
          <h3 className="text-3xl font-bold heading-font text-violet-700 mb-2">{title}</h3>
          <div className="h-1 w-24 bg-gradient-to-r from-orange-500 to-pink-500 rounded-full"></div>
        </div>
        <Link to={linkTo} className="flex items-center gap-1 text-orange-500 hover:text-orange-600 font-semibold transition-colors">
          View All <ArrowRight size={18} />
        </Link>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {categoryProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default CategoryPreview;
